// An explicitly saved empty Banner Info must not revive legacy banner fields.
export function getBannerInfo(appointment) {
  if(Object.prototype.hasOwnProperty.call(appointment || {},"bannerInfo"))return String(appointment.bannerInfo ?? "");
  return [["Notes",appointment?.bannerNotes],["Design",appointment?.bannerDesign],["Contact",appointment?.bannerContact]]
    .filter(([,value])=>String(value ?? "").trim())
    .map(([label,value])=>`${label}: ${String(value).trim()}`).join("\n\n");
}
